import { cn } from '@/lib/utils';

export function StoryPageHeader({
  eyebrow,
  title,
  description,
  meta,
  actions,
  className = '',
}) {
  return (
    <section className={cn('mb-4 sm:mb-6', className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          {eyebrow && <p className="story-label mb-1.5">{eyebrow}</p>}
          <h1 className="story-title text-2xl sm:text-3xl">{title}</h1>
          {description && <p className="story-body mt-2 max-w-2xl text-sm sm:text-base">{description}</p>}
          {meta && <div className="story-meta mt-2">{meta}</div>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </section>
  );
}

export function StorySectionHeader({ title, description, count, actions, className = '' }) {
  return (
    <div className={cn('mb-3 flex items-end justify-between gap-3', className)}>
      <div className="min-w-0">
        <h2 className="story-section-title text-lg sm:text-xl">
          {title}
          {count !== undefined && <span className="story-meta ml-2 font-sans font-normal">({count})</span>}
        </h2>
        {description && <p className="story-meta mt-1">{description}</p>}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </div>
  );
}

export function StorySurface({ children, subtle = false, className = '', ...props }) {
  return (
    <div className={cn(subtle ? 'story-surface-subtle' : 'story-surface', className)} {...props}>
      {children}
    </div>
  );
}

export function StoryPill({ children, className = '' }) {
  return <span className={cn('story-pill', className)}>{children}</span>;
}

export function StoryProgress({ value = 0, className = '' }) {
  const safeValue = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className={cn('story-progress-track', className)}>
      <div className="story-progress-fill" style={{ width: `${safeValue}%` }} />
    </div>
  );
}

export function StoryEmptyState({ icon: Icon, title, description, action, className = '' }) {
  return (
    <div className={cn('story-surface-subtle px-5 py-10 text-center sm:py-14', className)}>
      {Icon && (
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--story-accent-soft)] text-[var(--story-primary)]">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="story-section-title text-lg">{title}</h3>
      {description && <p className="story-body mx-auto mt-2 max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
}
